import { ActionIcon, TextInput, Tooltip } from "@mantine/core";
import { IconInfoCircle, IconX } from "@tabler/icons-react";
import type { ChangeEvent } from "react";
import { Flex } from "src/styled";

import NMEASortButton from "./NMEASortButton";

interface Props {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  sortAscending: boolean;
  onToggleSort: () => void;
}

const NMEATimeSearchInput = ({
  value,
  onChange,
  onClear,
  sortAscending,
  onToggleSort,
}: Props) => {
  return (
    <Flex
      align="center"
      gap={8}
      justify="flex-end"
      style={{ flexShrink: 0, flexWrap: "nowrap" }}>
      <Tooltip
        multiline
        maw={320}
        label={
          'Use "05" for hour 05XX, "0525" for nearest rows around 05:25, or ranges like "00-04", "0000 0400", "0025-04".'
        }>
        <ActionIcon variant="subtle" size="sm" mr={-4}>
          <IconInfoCircle size={16} />
        </ActionIcon>
      </Tooltip>

      <TextInput
        value={value}
        onChange={onChange}
        placeholder="Search by time"
        size="xs"
        styles={{ input: { minWidth: 160 } }}
        rightSection={
          value ? (
            <ActionIcon
              variant="transparent"
              size="sm"
              c="dimmed"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onClear();
              }}>
              <IconX size={13} />
            </ActionIcon>
          ) : (
            <div style={{ width: 16, height: 16 }} />
          )
        }
      />

      <NMEASortButton
        sortAscending={sortAscending}
        onToggleSort={onToggleSort}
      />
    </Flex>
  );
};

export default NMEATimeSearchInput;
